let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lTiBM")).then(() => parcelRequire('c40YO'));